import { render, staticRenderFns } from "./ModalDownloadSaved.vue?vue&type=template&id=27d0f4c9&"
import script from "./ModalDownloadSaved.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadSaved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports